"use strict";
/**
 * Utils to calculate taxes.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApplicableTaxesForCountry = exports.getApplicableTaxes = void 0;
var TaxType_1 = require("./types/TaxType");
var utils_1 = require("./utils");
var vat_1 = require("./vat");
var gst_1 = require("./gst");
var european_countries_1 = require("./european-countries");
__exportStar(require("./european-countries"), exports);
__exportStar(require("./vat"), exports);
__exportStar(require("./gst"), exports);
__exportStar(require("./types/TaxType"), exports);
/**
 * Returns a list of taxes that may apply for this countribution type
 */
exports.getApplicableTaxes = function (account, host, tierType) {
    var taxes = [];
    var accountCountry = utils_1.getCountryFromAccount(account);
    var hostCountry = utils_1.getCountryFromAccount(host);
    var vatType = vat_1.getAccountVATType(account);
    if (vatType) {
        var vatOriginCountry = void 0;
        if (vatType === 'OWN') {
            vatOriginCountry = vat_1.getVatOriginCountry(tierType, accountCountry, accountCountry);
        }
        else {
            vatOriginCountry = vat_1.getVatOriginCountry(tierType, hostCountry, accountCountry);
        }
        if (vat_1.vatMayApply(tierType, vatOriginCountry)) {
            var vatRate = vat_1.getStandardVatRate(tierType, vatOriginCountry);
            taxes.push({ type: TaxType_1.TaxType.VAT, percentage: vatRate });
        }
    }
    if (gst_1.accountHasGST(host) && gst_1.gstMayApply(tierType)) {
        taxes.push({ type: TaxType_1.TaxType.GST, percentage: gst_1.GST_RATE_PERCENT });
    }
    return taxes;
};
/**
 * Returns a list of taxes that may apply for this account
 */
exports.getApplicableTaxesForCountry = function (country) {
    var taxes = [];
    if (!country) {
        return [];
    }
    else if (european_countries_1.isMemberOfTheEuropeanUnion(country)) {
        taxes.push(TaxType_1.TaxType.VAT);
    }
    else if (country === 'NZ') {
        taxes.push(TaxType_1.TaxType.GST);
    }
    return taxes;
};
//# sourceMappingURL=index.js.map